import { render } from "./positions.vue?vue&type=template&id=77283f3b&scoped=true"
import script from "./positions.vue?vue&type=script&lang=js"
export * from "./positions.vue?vue&type=script&lang=js"

import "./positions.vue?vue&type=style&index=0&id=77283f3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77283f3b"]])

export default __exports__